/**
 * O dia das mensagens na conversa (spec 068, D1). Puro de propósito: a guarda
 * apps/api/src/shared/chat-day.test.ts confere o rótulo e a troca de dia.
 *
 * Tudo no fuso de quem olha: a mesma mensagem das 23h de um lado é de outro
 * dia para quem está noutro fuso, e o separador diz o dia de quem lê.
 */

const WEEKDAY = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];

const pad = (n: number) => String(n).padStart(2, '0');

function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/** "Hoje", "Ontem" ou "seg., 27/10/2026" */
export function dayLabel(day: Date, now: Date): string {
  if (Number.isNaN(day.getTime())) return '';
  // arredondado: o dia do horário de verão tem 23 ou 25 horas
  const diff = Math.round((startOfDay(now) - startOfDay(day)) / 86_400_000);
  if (diff === 0) return 'Hoje';
  if (diff === 1) return 'Ontem';
  return `${WEEKDAY[day.getDay()]}., ${pad(day.getDate())}/${pad(day.getMonth() + 1)}/${day.getFullYear()}`;
}

/** a mensagem `current` abre um dia novo em relação à anterior (a primeira sempre abre) */
export function startsNewDay(previous: string | Date | undefined, current: string | Date): boolean {
  if (previous === undefined) return true;
  return startOfDay(new Date(previous)) !== startOfDay(new Date(current));
}
